import LotSummary from "./LotSummary";

export default LotSummary;